<script lang="tsx">
import { computed, defineComponent, reactive, toRefs } from 'vue'
import { AuthBtn } from '@/components/business/FlowDeal/config'

import { Node } from '@antv/x6'
import StatusIcon from '@/components/business/FlowDeal/components/StatusIcon.vue'
import { ApproveStatus } from '@/enums/flow'

const props = {
  node: {
    type: Node,
    default: () => ({})
  }
}

export default defineComponent({
  name: 'FlowResult',
  props,
  setup(props) {
    const { node } = props
    let flowData = reactive({ current: node.getData() })
    const { current } = toRefs(flowData)
    const status = computed(() => {
      let arr = []
      if (current.value?.logs?.length) {
        arr = current.value?.logs.map((item: any) => item.action)
      }
      console.log(arr.includes(AuthBtn.REJECT), 'oooooo')
      if (arr.includes(AuthBtn.ADD_SIGN)) return AuthBtn.ADD_SIGN
      if (arr.includes(AuthBtn.ROLLBACK)) return AuthBtn.ROLLBACK
      if (arr.includes(AuthBtn.TRANSFER)) return AuthBtn.TRANSFER
      if (arr.includes(AuthBtn.REJECT)) return AuthBtn.REJECT
      if (arr.includes(AuthBtn.PASS)) return AuthBtn.PASS
      return current.value.state || ''
    })

    return () => (
      <div class={'flow-wrap'}>
        <div class="flow-name">{current.value.name}</div>
        <div class="tw-px-[12px]">
          <a
            class="tw-flex tw-justify-between tw-items-center"
            title={current.value?.operators.join('、')}
          >
            {current.value?.operators?.length ? (
              <span class="flow-operator">{current.value?.operators.join('、')}</span>
            ) : current.value.approvalType === 'LEVEL' ? (
              <span class="flow-operator">逐级审批</span>
            ) : (
              ''
            )}
            {status.value ? <StatusIcon status={status.value}></StatusIcon> : ''}
          </a>
          <a class="flow-log tw-z-30" title={current.value?.ccOperators?.join('、')}>
            {current.value?.ccOperators?.length ? (
              <div class="tw-flex tw-justify-between">
                <span class="send-text">
                  抄送：
                  {current.value?.ccOperators?.join('、')}
                </span>
                <span class="icon iconfont icon-Frame-2"></span>
              </div>
            ) : (
              ''
            )}
          </a>
        </div>
      </div>
    )
  }
})
</script>
<style scoped lang="scss">
.flow-wrap {
  width: 180px;
  padding: 0;
  justify-content: center;
  align-items: flex-start;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 2px 5px 0 #00000014;
  cursor: pointer;
  height: 75px;
  overflow: hidden;
  .flow-name {
    color: #fff;
    font-size: 12px;
    line-height: 28px;
    margin-bottom: 8px;
    background-color: #5687ff;
    padding: 0 12px;
    word-break: break-all;
  }
  .flow-operator {
    color: #999999;
    font-size: 12px;
    line-height: 20px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .flow-icon {
    margin-left: 2px;
    width: 16px;
    height: 16px;
  }
  .flow-log {
    width: 100%;
    height: 20px;
    font-size: 12px;
    line-height: 20px;
    color: #999999;
    margin-bottom: 8px;
    .send-text {
      width: calc(100% - 20px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flow-warp__done {
  box-shadow: 0 0 0 3px rgba(48, 129, 242, 0.2);
  border: 1px solid #5687ff;
  box-sizing: border-box;
}
.flow-warp__reject {
  box-shadow: 0 0 0 2px #fab5b5 !important;
  border: 1px solid #f34444 !important;
  box-sizing: border-box;
}
.reject {
  color: #f34444;
}
</style>
